export { default } from './SWSectionFiftyFiftyBanner';
